import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

export default function Header({ onHistoryClick }) {
  const { user, logout, credits } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const isPro = credits?.is_pro;
  const availableCredits = credits?.available_credits ?? 0;

  return (
    <>
      <header className="header">
        {/* Logo */}
        <Link to="/" className="header-logo" onClick={() => setMenuOpen(false)}>
          <img src="/logo.svg" alt="PuzzleForge" className="header-logo-img" />
        </Link>

        {/* Right side — credits badge + menu */}
        <div className="header-right">
          {user && credits !== null && (
            isPro ? (
              <Link to="/upgrade" className="credit-badge pro mono">⚡ Pro</Link>
            ) : availableCredits > 0 ? (
              <Link to="/upgrade" className="credit-badge credits mono">🎯 {availableCredits}</Link>
            ) : (
              <Link to="/upgrade" className="credit-badge empty mono">+ Credits</Link>
            )
          )}
          <button
            className="header-menu-btn"
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Menu"
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </header>

      {/* Dropdown menu */}
      {menuOpen && (
        <div className="header-menu-overlay" onClick={() => setMenuOpen(false)}>
          <div className="header-menu" onClick={e => e.stopPropagation()}>
            {user ? (
              <>
                <div className="menu-user mono">👤 {user.email.split('@')[0]}</div>
                <Link to="/upgrade" className="menu-item mono" onClick={() => setMenuOpen(false)}>
                  🎯 Get Credits
                </Link>
                <button className="menu-item mono" onClick={() => { onHistoryClick?.(); setMenuOpen(false); }}>
                  📋 Puzzle History
                </button>
                <button className="menu-item logout mono" onClick={handleLogout}>
                  🚪 Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="menu-item mono" onClick={() => setMenuOpen(false)}>
                  🔑 Login
                </Link>
                <Link to="/register" className="menu-item mono signup" onClick={() => setMenuOpen(false)}>
                  ✨ Sign Up Free
                </Link>
                <Link to="/upgrade" className="menu-item mono" onClick={() => setMenuOpen(false)}>
                  🎯 Get Credits
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
